
import { Component, Mixins } from "vue-property-decorator";
import {
  IItem,
  instanceOfIMksTemplateExecutable,
  instanceOfIDynamicTemplateExecutable,
  IMksTemplateExecutable,
  IDynamicTemplateExecutable,
} from "../../../../../domain/document/items";
import {
  ExternalTemplateExecuteResult,
} from "../../../../../domain/localhost/items";
import { CommonComponentsAccessor } from "../../CommonComponentsAccessor";

@Component
export default class ExternalTemplateInputtableMixin extends Mixins() {
  editingSource: IItem;
  commonComponents: CommonComponentsAccessor;

  async inputExternalTemplateWhenNeeded(): Promise<boolean> {
    const result = (await this.inputMksTemplateWhenNeeded()) || (await this.inputDynamicTemplateWhenNeeded());
    return result;
  }

  private async inputMksTemplateWhenNeeded(): Promise<boolean> {
    try {
      if (!instanceOfIMksTemplateExecutable(this.editingSource)) {
        return false;
      }
      const adapter = this.commonComponents.adapters.mksTemplate;
      if (!adapter.isInputable(this.editingSource)) {
        return false;
      }
      this.applyMksTemplateResult(await adapter.input(this.editingSource));
      return true;
    } catch (e) {
      this.$error("エラー", "MKSテンプレート選択処理が完了できませんでした。", e);
    }
  }

  private async inputDynamicTemplateWhenNeeded(): Promise<boolean> {
    try {
      if (!instanceOfIDynamicTemplateExecutable(this.editingSource)) {
        return false;
      }
      const adapter = this.commonComponents.adapters.dynamicTemplate;
      if (!adapter.isInputable(this.editingSource)) {
        return false;
      }
      this.applyDynamicTemplateResult(await adapter.input(this.editingSource));
      return true;
    } catch (e) {
      this.$error("エラー", "ダイナミックテンプレート選択処理が完了できませんでした。", e);
    }
  }

  private applyMksTemplateResult(result: ExternalTemplateExecuteResult): void {
    if (!result) {
      return;
    }
    const cloned = this.editingSource.clone() as IMksTemplateExecutable;
    cloned.mksTemplateRegisteredId = result.registeredId;
    cloned.setValueFromExternalScript(result.value);
    cloned.adjustObjectHeight();
    cloned.adjustFontSize();
    this.editingSource = cloned;
    const extraPageEditor = this.commonComponents.editors.extraPage;
    if (!extraPageEditor.isAddibleOverflowedTextPage(cloned)) {
      return;
    }
    this.commonComponents.editors.extraPage.addOverflowedTextPage(cloned);
  }

  private applyDynamicTemplateResult(result: ExternalTemplateExecuteResult): void {
    if (!result) {
      return;
    }
    const cloned = this.editingSource.clone() as IDynamicTemplateExecutable;
    cloned.dynamicTemplateRegisteredId = result.registeredId;
    cloned.setValueFromExternalScript(result.value);
    cloned.adjustObjectHeight();
    cloned.adjustFontSize();
    this.editingSource = cloned;
    const extraPageEditor = this.commonComponents.editors.extraPage;
    if (!extraPageEditor.isAddibleOverflowedTextPage(cloned)) {
      return;
    }
    this.commonComponents.editors.extraPage.addOverflowedTextPage(cloned);
  }
}
